import { useAuthenticator, Alert } from '@aws-amplify/ui-react';
import React, { useCallback, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { resetPassword } from 'aws-amplify/auth';
import { confirmResetPassword } from 'aws-amplify/auth';
import "./App.scss";

const SubmitView = React.memo(({ formData, handleInputChange, error }) => (
  <div>
    <Form.Group controlId="code">
      <Form.Label>Code</Form.Label>
      <Form.Control
        autoFocus
        placeholder="Code"
        autoComplete="off"
        name="code"
        value={formData.code}
        onChange={handleInputChange}
      />
    </Form.Group>
    <Form.Group controlId="password">
      <Form.Label>New Password</Form.Label>
      <Form.Control
        placeholder="New Password"
        autoComplete="off"
        autoFocus
        type="password"
        name="password"
        value={formData.password}
        onChange={handleInputChange}
      />
    </Form.Group>
    {error.hasError && <p className='errorMessage'>{error.message}</p>}
  </div>
))

const SendView = React.memo(({ formData, error, handleInputChange }) => (
  <div>
    <Form.Group controlId="email">
      <Form.Label>Email *</Form.Label>
      <Form.Control
        autoFocus
        autoComplete='off'
        placeholder="Enter your email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleInputChange}
      />
      {error.hasError && <p className='errorMessage'>{error.message}</p>}
    </Form.Group>
  </div>
))

const initialFormState = {
  email: '',
  code: '',
  password: ''
}

export function CustomForgotPassword() {
  const { toSignIn } = useAuthenticator();
  const [delivery, setDelivery] = useState(false);
  const [error, setError] = useState({ hasError: false, message: '' });
  const [formData, setFormData] = useState(initialFormState);
  const [showCodeConfirmationAlert, setShowCodeConfirmationAlert] = useState(false);

  const clearError = () => setError({ hasError: false, message: '' });
  const setNewError = (message) => setError({ hasError: true, message });

  const handleInputChange = useCallback((e) => {
    clearError();
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const handleSendCode = useCallback(async (e) => {
    e.preventDefault();
    clearError();
    try {
      await resetPassword({ username: formData.email });
      setDelivery(true);
    } catch (error) {
      setNewError(error.message);
    }
  }, [formData.email]);

  const handleSubmitCode = useCallback(async (e) => {
    e.preventDefault();
    clearError()
    try {
      await confirmResetPassword({ username: formData.email, confirmationCode: formData.code, newPassword: formData.password });
      toSignIn()
    } catch (error) {
      setNewError(error.message)
    }
  }, [formData.email, formData.code, formData.password, toSignIn])

  return (
    <div className="login">
      {showCodeConfirmationAlert && <Alert variation='success' className='alertCustom' isDismissible onDismiss={() => setShowCodeConfirmationAlert(false)}>A verification code has been sent to your email.</Alert>}
      <div className="blurred-bg"></div>
      <div className="login-form-container">
        <form
          className="form-signin"
          onSubmit={delivery ? handleSubmitCode : handleSendCode}
        >
          <header className="text-center mb-4">
            <div className="mb-4 login-logo"></div>
            <h1 className="h1 mb-3">Reset your password</h1>
          </header>
          <div>
            {delivery ? (
              <SubmitView
                formData={formData}
                error={error}
                handleInputChange={handleInputChange}
              />
            ) : (
              <SendView
                formData={formData}
                error={error}
                handleInputChange={handleInputChange}
              />
            )}

          </div>
          <footer>
            <Form.Row>
              {delivery ? (
                <Button block size="lg" type="submit">
                  Submit
                </Button>
              ) : (
                <Button block size="lg" type="submit">
                  Send Code
                </Button>
              )}
            </Form.Row>

            <Form.Row>
              {delivery ? (
                <Button
                  variant="link"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowCodeConfirmationAlert(true)
                    handleSendCode(e);
                  }}
                >
                  Resend Code
                </Button>
              ) : (
                <Button
                  variant="link"
                  onClick={() => toSignIn()}
                >
                  Back to Sign In
                </Button>
              )}
            </Form.Row>
          </footer>
        </form>
      </div>
    </div>
  );
}
